import React from 'react'
import PropTypes from 'prop-types'

const QuantityRows = (props) => {
    const rows = props.data.map((row, i) => <td key={'qty-' + i} style={props.style.bodyStyle}>{row ? row : ''}</td>);
    return (
        <tr style={{backgroundColor: '#e5e5e5'}} key={'module-row'}>
            <th style={props.style.headerStyle} key={'quantity-header'}>Module Qty</th>
            {rows}
        </tr>
    )
};

QuantityRows.props = {
    data: PropTypes.array.isRequired
};
export default QuantityRows;